import { useContext } from 'react';
import { ChatContext, ChatContextProvider } from '../../context/ChatContext';
import { useAppSelector } from '../../store/store';
import { useLocation } from 'react-router-dom';
import ChatFooter from './ChatFooter';
import ChatBody from './ChatBody';
import ChatHeader from './ChatHeader';
import styles from './Chat.module.scss';

interface Props {
  style?: React.CSSProperties;
  hideAssignBtn?: boolean;
  chatBodyStyle?: React.CSSProperties;
}

export default function Chat({ style, chatBodyStyle, hideAssignBtn }: Props) {
  const location = useLocation();

  if (location.pathname.includes('/web/video-call')) {
    return <ChatComponent style={style} chatBodyStyle={chatBodyStyle} />;
  }

  return (
    <ChatContextProvider>
      <ChatComponent style={style} chatBodyStyle={chatBodyStyle} hideAssignBtn={hideAssignBtn} />
    </ChatContextProvider>
  );
}

function ChatComponent({ style, hideAssignBtn, chatBodyStyle }: Props) {
  const { chatConversation, action, currentConversation, conversationParticipants } =
    useAppSelector((state) => state.chat);
  const {
    newMessage,
    setNewMessage,
    sendMessage,
    addChatParticipant,
    closeConversation,
    handleTyping,
    userIsTyping,
  } = useContext(ChatContext);

  const handleTextinput = (value: string) => {
    setNewMessage(value);
  };

  return (
    <>
      {currentConversation ? (
        <div className={styles.mainChatWrapper}>
          <div className={styles.chatWrapper} style={style}>
            <ChatHeader
              currentConversation={currentConversation}
              addChatParticipant={addChatParticipant}
              hideAssignBtn={hideAssignBtn || false}
              closeConversation={closeConversation}
            />
            <ChatBody
              chatHistory={chatConversation}
              isLoading={
                action.status === 'loading' && action.actionType === 'GET_CONVERSATION_HISTORY'
              }
              conversationParticipants={conversationParticipants}
              style={chatBodyStyle}
            />
            <ChatFooter
              handleTextinput={handleTextinput}
              handleTyping={() => handleTyping()}
              sendMessage={sendMessage}
              newMessage={newMessage}
              userIsTyping={userIsTyping}
              currentConversation={currentConversation}
            />
          </div>
        </div>
      ) : null}
    </>
  );
}
